import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Collapse,
  Avatar,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
} from "@mui/material";
import {
  ExpandMore,
  ExpandLess,
  Notifications,
  CalendarToday,
} from "@mui/icons-material";

export default function ReturnandRefundPolicy() {
  const [openRow, setOpenRow] = useState(null);
  const [searchText, setSearchText] = useState("");

  const rows = [
    {
      id: 6548,
      orderDate: "2 min ago",
      requestDate: "₹654",
      payment: "CC",
      status: "Completed",
      refundDetails: {
        productPrice: 800,
        productDiscount: 50,
        couponDiscount: 100,
        productTax: 20,
        returnDeductions: 30,
      },
    },
    {
      id: 6549,
      orderDate: "5 min ago",
      requestDate: "₹750",
      payment: "COD",
      status: "Pending",
      refundDetails: {
        productPrice: 1000,
        productDiscount: 100,
        couponDiscount: 150,
        productTax: 50,
        returnDeductions: 20,
      },
    },
    {
      id: 6550,
      orderDate: "10 min ago",
      requestDate: "₹500",
      payment: "UPI",
      status: "Canceled",
      refundDetails: {
        productPrice: 1000,
        productDiscount: 100,
        couponDiscount: 150,
        productTax: 50,
        returnDeductions: 20,
      },
    },
  ];

  const handleRowToggle = (rowId) => {
    setOpenRow(openRow === rowId ? null : rowId);
  };

  const filteredRows = rows.filter((row) =>
    row.id.toString().includes(searchText)
  );

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* AppBar */}
        <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px"
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Return and Refund Policy
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar>

        {/* Search Bar */}
        <TextField
          label="Search by order id"
          variant="outlined"
          size="small"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{ marginBottom: 2, width: "250px" }}
        />

        {/* Table */}
        <TableContainer component={Paper} sx={{  borderRadius: "20px",}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight:"bold"}}>ORDER ID</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>ORDER DATE</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>REQUEST DATE</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>PAYMENT</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>STATUS</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((row) => (
                <React.Fragment key={row.id}>
                  <TableRow>
                    <TableCell sx={{fontWeight:"bold"}}>#{row.id}</TableCell>
                    <TableCell>{row.orderDate}</TableCell>
                    <TableCell sx={{fontWeight:"bold"}}>{row.requestDate}</TableCell>
                    <TableCell>{row.payment}</TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          color:
                            row.status === "Completed"
                              ? "green"
                              : row.status === "Pending"
                              ? "orange"
                              : "red",
                              fontWeight:"bold"
                        }}
                      >
                        {row.status}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {row.refundDetails ? (
                        <IconButton onClick={() => handleRowToggle(row.id)}>
                          {openRow === row.id ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                      ) : null}
                    </TableCell>
                  </TableRow>

                  {/* Collapsible Row */}
                  {row.refundDetails && (
                    <TableRow>
                      <TableCell colSpan={6} style={{ padding: 0 }}>
                        <Collapse
                          in={openRow === row.id}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ margin: 2 }}>
                            <Typography variant="h6" gutterBottom>
                              Refund Reason:
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry.
                            </Typography>

                            <Box sx={{ marginTop: 2 }}>
                              <Typography variant="body2">
                                Product Price (x1):{" "}
                                <b>+₹{row.refundDetails.productPrice}</b>
                              </Typography>
                              <Typography variant="body2">
                                Product Discount:{" "}
                                <span style={{ color: "red" }}>
                                  -₹{row.refundDetails.productDiscount}
                                </span>
                              </Typography>
                              <Typography variant="body2">
                                Coupon Discount:{" "}
                                <span style={{ color: "red" }}>
                                  -₹{row.refundDetails.couponDiscount}
                                </span>
                              </Typography>
                              <Typography variant="body2">
                                Product Tax: +₹{row.refundDetails.productTax}
                              </Typography>
                              <Typography variant="body2">
                                Return Deductions: -₹
                                {row.refundDetails.returnDeductions}
                              </Typography>

                              <Typography
                                variant="h6"
                                sx={{
                                  marginTop: 1,
                                  color: "red",
                                  fontWeight: "bold",
                                }}
                              >
                                Total Refundable Amount: -₹730.00
                              </Typography>
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
